import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=2c3231d3&scoped=true&"
import script from "./sidebarItem.vue?vue&type=script&lang=js&"
export * from "./sidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sidebarItem.vue?vue&type=style&index=1&id=2c3231d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3231d3",
  null
  
)

export default component.exports